module.exports = __webpack_public_path__ + "assets/fonts/Alibaba-PuHuiTi-Regular.8d591595.ttf";